export default __webpack_public_path__ + "static/media/bg-coworking.06bccc47.jpeg";